import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import MLink from '@material-ui/core/Link';
import clsx from 'clsx';
import { useAppContext } from '../contexts/app';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    margin: theme.spacing(4, 0),
    border: `2px solid ${theme.palette.secondary.main}`,
  },
  compact: {
    margin: theme.spacing(2, 0),
  },
}));

const LoginRequiredNotice = ({ returnTo, action, className, compact }) => {
  const classes = useStyles();
  const { login } = useAppContext();

  return (
    <Paper className={clsx(classes.card, className, { [classes.compact]: compact })}>
      You must
      {' '}
      <MLink
        href="/login"
        onClick={(e) => {
          e.preventDefault();
          login(returnTo);
        }}
      >
        log in
      </MLink>
      {' '}
      to {action}.
    </Paper>
  );
};

LoginRequiredNotice.propTypes = {
  returnTo: PropTypes.string,
  action: PropTypes.string,
  className: PropTypes.string,
  compact: PropTypes.bool,
};

LoginRequiredNotice.defaultProps = {
  action: 'use this feature',
  compact: false,
};

export default LoginRequiredNotice;
